// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

/**
 * System variables for a telemetry item.
 */
var Envelope =
/** @class */
function () {
  function Envelope() {
    this.ver = 1;
    this.sampleRate = 100.0;
    this.tags = {};
  }

  return Envelope;
}();

export { Envelope };